import { useQuery } from 'react-query';
import axiosInstance from '../config/Axios';

/**
 * Smart Template Engine — Preview System (3D + 2B).
 *   GET /video-walls/{id}/content-check  → { content_check }  (scheduled vs actual)
 *   GET /video-walls/{id}/resolve-at?dow&minutes → { resolved } (what plays at T)
 * Resource-wrapped; unwrap `res?.data ?? res`.
 */

export const useContentCheck = (wallId, enabled = true) => useQuery(
  ['wallContentCheck', wallId],
  async () => {
    const res = (await axiosInstance.get(`/video-walls/${wallId}/content-check`)).data;
    return (res?.data ?? res)?.content_check ?? null;
  },
  { enabled: !!wallId && enabled, refetchInterval: 20_000, staleTime: 10_000 },
);

export const useResolveAt = (wallId, dow, minutes, enabled = true) => useQuery(
  ['wallResolveAt', wallId, dow, minutes],
  async () => {
    const res = (await axiosInstance.get(`/video-walls/${wallId}/resolve-at`, { params: { dow, minutes } })).data;
    return (res?.data ?? res)?.resolved ?? null;
  },
  { enabled: !!wallId && enabled, keepPreviousData: true, staleTime: 30_000 },
);
